<template>
  <div class="redirect">
    <div class="title">
      <h3>Đang chuyển trang, vui lòng đợi trong giây lát...</h3>
    </div>
    <div class="loading">
      <div class="el-icon-loading"></div>
    </div>
  </div>
</template>

<script>
  import authenService from "../../services/authenService";
  import userService from "../../services/userService";
  import crypto from "crypto";
  import VueCookies from "vue-cookies";

  export default {
    name: "LoginCallback",

    data() {
      return {};
    },

    created() {
      this.saveToken();
    },

    methods: {

      /**
       * IdHash :  phục vụ cho việc check quyền download file;
       * @param user
       */
      storeIdHash(user) {
        let idHash = crypto
          .createHash("md5")
          .update(user.id + user.userName)
          .digest("hex");
        VueCookies.set("IdHash", idHash, -1);
      },

      defaultRouting() {
        // this.$router.replace({name: "otp"});
        this.$router.replace({name: "beforeEnterApp"});
      },

      saveToken() {
        let hash = window.location.hash;
        let loginCallbackPrefix = "#/loginCallback";
        hash.startsWith(loginCallbackPrefix) &&
        (hash = hash.substr(
          hash.indexOf(loginCallbackPrefix) + loginCallbackPrefix.length
        ));

        const tokenData = {};

        hash
          .substr(1)
          .split("&")
          .forEach(item => {
            const elements = item.split("=");
            tokenData[decodeURI(elements[0])] = decodeURI(elements[1]);
          });

        authenService
          .saveToken(tokenData)
          .then(() => userService.get().then(response => response.data))
          .then(user => this.storeIdHash(user))
          .then(() => this.defaultRouting());
      }
    }
  };
</script>

<style>
  .redirect {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/views/login/LoginCallback.vue